import {
  TableAdapter,
  TableAdapterHook,
  TableAdapterStatus,
} from 'src/components/DataTable/types/DataTable';
import { useGetReports } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportsWrapper/hooks/useGetReports';
import {
  ReportUI,
  transformReportModelToUI,
} from 'src/components/enterprise/features/Reporting/ManageReportsPage/utils/reportUI.utils';

export function createReportsAdapter(
  corpId: string
): TableAdapterHook<ReportUI> {
  return function useReportsAdapterHook(): TableAdapter<ReportUI> {
    const { reports, isLoading, error, fetch } = useGetReports({ corpId });

    const status =
      (isLoading && TableAdapterStatus.LOADING) ||
      (error && TableAdapterStatus.ERROR) ||
      TableAdapterStatus.SUCCESS;
    const reportRows = reports.map(transformReportModelToUI);

    return {
      data: reportRows,
      total: reportRows.length,
      status,
      error,
      fetch,
    };
  };
}
